import { dscvrIcApi } from '@/shared/api';

export const useReadAllNotificationMutation = () => {
  return dscvrIcApi.notification.setReadAllNotifications();
};
